export const getCorrectGuessStyle = (correctGuesses, id) =>
  correctGuesses.includes(id) && {
    display: 'none',
  };
